'use client';

/**
 * Command Center Dashboard Client Wrapper
 *
 * This component must include its own providers to ensure proper hydration.
 * The layout's providers don't properly hydrate children passed through
 * server component boundaries in Next.js static export.
 */

import { WorkspaceProvider } from '@/lib/archimate/WorkspaceContext';
import { CommandCenterProvider } from '@/lib/command-center/CommandCenterContext';
import CommandCenterHeader from '@/components/command-center/CommandCenterHeader';
import CommandCenterDashboard from './page-client';

export default function CommandCenterClientWrapper() {
  return (
    <WorkspaceProvider>
      <CommandCenterProvider>
        <CommandCenterHeader />
        <CommandCenterDashboard />
      </CommandCenterProvider>
    </WorkspaceProvider>
  );
}
